'use es6';

import { forwardRef, useEffect } from 'react';
import devLogger from 'react-utils/devLogger';
import getComponentName from 'react-utils/getComponentName';
import { attachWrappedComponent, getCoreComponent } from './utils';
import { Metrics } from './../utils/Metrics';
import { jsx as _jsx } from "react/jsx-runtime";
export default function (reason, url) {
  return Component => {
    const componentName = getComponentName(Component);

    // Remove HoC wrappers from the logged displayname (ex. "MyComponent" instead of "Controllable(MyComponent)")
    const coreComponentName = getComponentName(getCoreComponent(Component));
    const message = `\`${coreComponentName}\` is deprecated and will be removed in a future version. ${reason}`;
    const DeprecatedComponent = /*#__PURE__*/forwardRef((props, ref) => {
      useEffect(() => {
        Metrics.counter('deprecated-component-rendered', {
          component_name: coreComponentName
        }).increment();
      }, []);
      devLogger.warn({
        message,
        key: `deprecated-${componentName}`,
        url
      });
      return /*#__PURE__*/_jsx(Component, Object.assign({}, props, {
        ref: ref
      }));
    });
    DeprecatedComponent.isDeprecated = true;
    DeprecatedComponent.deprecated = {
      reason,
      url
    };
    DeprecatedComponent.displayName = `Deprecated(${componentName})`;
    DeprecatedComponent.propTypes = Component.propTypes;
    DeprecatedComponent.defaultProps = Component.defaultProps;
    attachWrappedComponent(DeprecatedComponent, Component);
    return DeprecatedComponent;
  };
}